import type { CompanySelectObject } from "app/pages/sales-intelligence/modules/leads-search-filters/types/description.dto";
import type { IDropDownExtendedItem } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/ControlledMultiDropdown/ControlledMultiDropdown";

export const mapCompanyDomainsToOptions = (
    companyOptions: readonly CompanySelectObject[],
): readonly IDropDownExtendedItem[] => {
    return (
        companyOptions?.map((company) => ({
            id: company.domain,
            text: company.company || company.domain,
            key: company.domain,
            iconSrc: company.icon,
        })) ?? []
    );
};
